var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex items-center bottom-4", class: _vm.ckickableClass },
    [
      _c(
        "div",
        {
          staticClass: "flex-shrink-0 resources-avatar",
          class: _vm.avatarOnly ? "tooltip" : "",
        },
        [
          _vm.image
            ? [
                _c(
                  "div",
                  {
                    staticClass:
                      "resources-avatar border-2 rounded-full flex items-center justify-center",
                    class: _vm.customAvatarStyle,
                  },
                  [
                    _c("S3Image", {
                      staticClass:
                        "inline-block resources-avatar rounded-full object-cover object-center z-10",
                      attrs: { s3FileKey: _vm.image },
                    }),
                  ],
                  1
                ),
              ]
            : [
                _c(
                  "div",
                  {
                    staticClass:
                      "resources-avatar rounded-full flex items-center justify-center",
                    style: _vm.bgStyle,
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "inline-flex items-center justify-center resources-avatar rounded-full uppercase",
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "text-xl leading-none text-white" },
                          [_vm._v(_vm._s(_vm.initial))]
                        ),
                      ]
                    ),
                  ]
                ),
              ],
          _vm.avatarOnly
            ? [
                _c("span", { staticClass: "tooltiptext bg-primary-500" }, [
                  _vm._v(" " + _vm._s(_vm.title) + " "),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
      [
        !_vm.avatarOnly
          ? _c("div", { class: !_vm.avatarOnly ? "" : "ml-2" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.title,
                      expression: "title",
                    },
                  ],
                  staticClass: "leading-5",
                },
                [_vm._v(" " + _vm._s(_vm.title) + " ")]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.subtitle,
                      expression: "subtitle",
                    },
                  ],
                  staticClass: "text-sm leading-5 text-gray-500",
                },
                [_vm._v(" " + _vm._s(_vm.subtitle) + " ")]
              ),
            ])
          : _vm._e(),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }